import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { Typography } from "../../../Styles/GlobalStyles/Variables";

export const ChangePasswordButton = styled(Button)(({ theme }) => ({
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    textTransform: "capitalize",
    padding: theme.spacing(2),
    fontFamily: Typography.primaryFont,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  /*   [theme.breakpoints.only("xs")]: {
      width: "50%",
    }, */
  }));